<template>
  <div>
    <editor v-model="editorValue" :init="init"></editor>
  </div>
</template>

<script setup>
import {reactive, ref, watch, toRefs} from "vue";
import tinymce from "tinymce/tinymce.js";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/themes/silver";
import "tinymce/icons/default";

import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis.js";
import "tinymce/plugins/table";
import "tinymce/plugins/quickbars";

import "tinymce-i18n/langs5/fr_FR.js";

import Editor from "@tinymce/tinymce-vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  selector: "textarea",
  plugins: [
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
  toolbar: {
    default:
      "bold italic link| alignleft aligncenter alignright alignjustify | fontsizeselect|formatselect|fontselect | undo redo ",
  },
});

const emit = defineEmits(["update:modelValue"]);

const init = reactive({
  language: "fr_FR",
  height: 200,
  menubar: false,
  content_css: false,
  skin: false,
  lists_indent_on_tab: false,
  advlist_bullet_styles: 'square',
  plugins: props.plugins,
  toolbar: props.toolbar,
  quickbars_insert_toolbar: false,
  branding: false,
});

const {modelValue} = toRefs(props);
const editorValue = ref(modelValue.value);

watch(modelValue, (newValue) => {
  editorValue.value = newValue;
});

watch(editorValue, (newValue) => {
  emit("update:modelValue", newValue);
});
</script>
<style>
.tox .tox-statusbar{
  display:none
}
</style>
